<template>
<div class="ratings" ref="ratingsWrapper">
	<div class="ratings-content">
		<div class="overview">
			<div class="overview-left">
				<h1 class="score">{{seller.score}}</h1>
				<div class="title">综合评分</div>
				<div class="rank">高于周边商家{{seller.rankRate}}</div>
			</div>
			<div class="overview-right">
				<div class="score-wrapper">
					<span class="title">服务态度</span>
					<star :size="36" :score="seller.serviceScore"></star>
					<span class="score">{{seller.serviceScore}}</span>
				</div>
				<div class="score-wrapper">
					<span class="title">商品评分</span>
					<star :size="36" :score="seller.foodScore"></star>
					<span class="score">{{seller.foodScore}}</span>
				</div>
				<div class="delivery-wrapper">
					<span class="title">送达时间</span>
					<span class="deliveryTime">{{seller.deliveryTime}}分钟</span>
				</div>
			</div>
		</div>
		<split></split>
		<ratingselect :select-type="selectType" :only-content="onlyContent" :ratings="ratings"></ratingselect>
		<div class="rating-wrapper">
			<ul>
				<li v-for="rating in ratings" class="rating-item" v-show="needShow(rating.rateType, rating.text)">
					<div class="avatar">
						<img :src="rating.avatar" width="28" height="28">
					</div>
					<div class="content">
						<h1 class="name">{{rating.username}}</h1>
						<div class="star-wrapper">
							<star :size="24" :score="rating.score"></star>
							<span class="delivery" v-show="rating.deliveryTime">{{rating.deliveryTime}}</span>
						</div>
						<p class="text">{{rating.text}}</p>
						<div class="recommend" v-show="rating.recommend && rating.recommend.length">
							<span class="icon-thumb_up"></span>
							<span class="item" v-for="item in rating.recommend">{{item}}</span>
						</div>
						<div class="time">
							{{rating.rateTime | formatDate}}
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</div>
</template>

<script>
import axios from 'axios';
import star from '@/components/star/star';
import split from '@/components/split/split';
import ratingselect from '@/components/ratingselect/ratingselect';
import {formatDate} from '@/common/js/date';
import BScroll from 'better-scroll';

const POSITIVE = 0;
const NEGATIVE = 1;
const ALL = 2;

export default {
	props: {
		seller: {
			type: Object
		}
	},
	data() {
		return {
			ratings: [],
			selectType: ALL,
			onlyContent: true,
		}
	},
	created() {
		axios.get('static/data.json').then((res) => {
			this.ratings = res.data.ratings;
			this.$nextTick(() => {
				this.scroll = new BScroll(this.$refs.ratingsWrapper, {
					click: true
				})
			})
		});
		// 获取子组件的selectType的更新
	    this.$root.eventHub.$on('ratingType.select', selectType => {
	        this.selectType = selectType;
	        this.$nextTick(() => {
	            this.scroll.refresh();
	        });
	    });

	    this.$root.eventHub.$on('content.toggle', onlyContent => {
	        this.onlyContent = onlyContent;
	        this.$nextTick(() => {
	            this.scroll.refresh();
	        });
	    });
	},
	methods: {
		needShow(type, text) {
            if (this.onlyContent && !text) {
                return false;
            }
            if (this.selectType === ALL) {
                return true;
            } else {
                return type === this.selectType;
            }
        }
	},
	filters: {
		formatDate(time) {
			let date = new Date(time);
			return formatDate(date, 'yyyy-MM-dd hh:mm');
		}
	},
	components: {
		star,
		split,
		ratingselect
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../common/scss/mixins";

.ratings {
	position: absolute;
	top: 174px;
	bottom: 0;
	width: 100%;
	overflow: hidden;
	.overview {
		display: flex;
		padding: 18px 0;
		.overview-left {
			flex: 0 0 137px;
			padding: 6px 0;
			width: 137px;
			border-right: 1px solid rgba(7,17,27,0.1);
			text-align: center;
			@media only screen and (max-width: 320px) {
				flex: 0 0 110px;
				width: 110px;
			}
			.score {
				margin-bottom: 12px;
				line-height: 28px;
				font-size: 24px;
				color: rgb(255,153,0);
			}
			.title {
				margin-bottom: 8px;
				line-height: 12px;
				font-size: 12px;
				color: rgb(7,17,27);
			}
			.rank {
				padding-bottom: 6px;
				line-height: 10px;
				font-size: 10px;
				color: rgb(147,153,159);
			}
		}
		.overview-right {
			flex: 1;
			padding:6px 0 6px 24px;
			@media only screen and (max-width: 320px) {
				padding: 6px;
			}
			.score-wrapper {
				margin-bottom: 8px;
				line-height: 18px;
				font-size: 0;
				.title {
					display: inline-block;
					vertical-align: top;
					font-size: 12px;
					color: rgb(7,17,27)
				}
				.star {
					display: inline-block;
					margin: 0 12px;
					vertical-align: top;
				}
				.score {
					display: inline-block;
					vertical-align: top;
					line-height: 18px;
					font-size: 12px;
					color: rgb(255,153,0);
				}
			}
			.delivery-wrapper {
				font-size: 0;
				.title {
					vertical-align: top;
					font-size: 12px;
					color: rgb(7,17,27)
				}
				.deliveryTime {
					margin-left: 12px;
					font-size: 12px;
					color: rgb(147,153,159);
				}
			}
		}
	}
	.rating-wrapper {
        padding: 0 18px;
        .rating-item {
            display: flex;
            padding: 18px 0;
            @include border-1px(rgba(7, 17, 27, .1))
            .avatar {
                flex: 0 0 28px;
                width: 28px;
                margin-right: 12px;
                img {
                    border-radius: 50%;
                }
            }
            .content {
                flex: 1;
                position: relative;
                .name {
                    margin-bottom: 4px;
                    line-height: 12px;
                    font-size: 10px;
                    color: rgb(7, 17, 27);
                }
                .star-wrapper {
                    margin-bottom: 6px;
                    font-size: 0;
                    .star {
                        display: inline-block;
                        vertical-align: top;
                        margin-right: 6px;
                    }
                    .delivery {
                        display: inline-block;
                        vertical-align: top;
                        line-height: 12px;
                        font-size: 10px;
                        color: rgb(147, 153, 159);
                    }
                }
                .text {
                    margin-bottom: 8px;
                    line-height: 18px;
                    color: rgb(7, 17, 27);
                    font-size: 12px;
                }
                .recommend {
                    line-height: 16px;
                    font-size: 0;
                    .icon-thumb_up, .item {
                        display: inline-block;
                        margin: 0 8px 4px 0;
                        font-size: 9px;
                    }
                    .icon-thumb_up {
                        color: rgb(0, 160, 220);
                    }
                    .item {
                        padding: 0 6px;
                        border: 1px solid rgba(7, 17, 27, .1);
                        border-radius: 1px;
                        color: rgb(147, 153, 159);
                        background: #fff;
                        font-size: 9px;
                    }
                }
                .time {
                    position: absolute;
                    top: 0;
                    right: 0;
                    line-height: 12px;
                    font-size: 10px;
                    color: rgb(147, 153, 159);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ratings/ratings.vue